import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';

const GetIpWhiteListAll = (params?: any): Promise<any> =>
    request({
        url: ApiURL.Query.GetIpWhiteListAll,
        method: RequestType.GET,
        params,
    });

const GetIpWhiteListById = (id: number): Promise<any> =>
    request({
        url: ApiURL.Query.GetIpWhiteListById,
        method: RequestType.GET,
        params: { id },
    });

const IpWhiteListQuery = {
    GetIpWhiteListAll,
    GetIpWhiteListById,
};

export default IpWhiteListQuery;

